import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const ButtonBase = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  margin: 0 auto;
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-3px);
    
    svg {
      transform: translateX(5px);
    }
  }

  svg {
    margin-left: 10px;
    transition: transform 0.3s ease;
  }

  /* Variante Primary */
  ${({ primary }) =>
    primary &&
    css`
      background: linear-gradient(90deg, #5ab9d3, #3a8ca8);
      box-shadow: 0 10px 30px rgba(90, 185, 211, 0.3);

      &:hover {
        background: linear-gradient(90deg, #3a8ca8, #5ab9d3);
        box-shadow: 0 15px 40px rgba(90, 185, 211, 0.4);
      }
    `}

  /* Responsividade */
  @media (max-width: 480px) {
    font-size: 1rem;
    padding: 14px 28px;
  }
`;

const Button = ({ children, primary, as, to, ...props }) => {
  if (as === Link) {
    return (
      <ButtonBase
        as={Link}
        to={to}
        primary={primary}
        {...props}
      >
        {children}
      </ButtonBase>
    );
  }

  return (
    <ButtonBase primary={primary} {...props}>
      {children}
    </ButtonBase>
  );
};

// Componente específico para o botão de cadastro
export const SignUpButton = () => (
  <Button
    as={Link}
    to="/sign-up"
    primary
  >
    Cadastre-se <FiArrowRight style={{ transition: 'transform 0.3s ease' }} />
  </Button>
);

export default Button;